module.exports = __webpack_public_path__ + "static/media/loading-bos.4c8ce55f.gif";